import { render, staticRenderFns } from "./SitemapPage.vue?vue&type=template&id=c468c268&scoped=true&"
import script from "./SitemapPage.vue?vue&type=script&lang=js&"
export * from "./SitemapPage.vue?vue&type=script&lang=js&"
import style0 from "./SitemapPage.vue?vue&type=style&index=0&id=c468c268&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c468c268",
  null
  
)

export default component.exports